import React from "react";
import { Phone, EnvelopeSimple, MapPin, MedalMilitary, ShieldCheck, Buildings, Sparkle, Certificate, ChatCircle, Clock } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import QuoteForm from "@/components/QuoteForm";
import WalkthroughScheduler from "@/components/WalkthroughScheduler";
import { SITE } from "@/lib/site";

const WHY = [
  { icon: MedalMilitary, text: "Veteran-Owned" },
  { icon: ShieldCheck, text: "Fully Insured" },
  { icon: Sparkle, text: "Medical Cleaning Specialists" },
  { icon: Buildings, text: "Government & Commercial Experience" },
  { icon: Certificate, text: "Quality Assurance Inspections" },
  { icon: ChatCircle, text: "Customized Cleaning Programs" },
  { icon: Clock, text: "Reliable · Professional · Responsive" },
];

export default function Quote() {
  return (
    <>
      <SEO title="Request Your Free Facility Assessment" description="Empire Serv — professional cleaning and facility maintenance for medical, government, industrial, and commercial facilities. Complete the assessment form for a tailored proposal." path="/quote" />
      <PageHero
        eyebrow="Request Your Free Facility Assessment"
        title="Professional cleaning solutions tailored to your business."
        subtitle="Tell us about your facility and service needs. A member of the Empire Serv team will contact you within one business day to discuss a customized cleaning solution."
        image="https://images.pexels.com/photos/6197110/pexels-photo-6197110.jpeg"
        height="h-[48vh]"
        testId="quote-hero"
      />

      <section className="es-section bg-white">
        <div className="es-container grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-8">
            <QuoteForm />
          </div>

          <aside className="lg:col-span-4 space-y-6 sticky top-28">
            <div className="bg-[var(--es-navy)] text-white p-8 rounded-sm">
              <div className="text-xs uppercase tracking-[0.25em] text-[var(--es-accent)] font-semibold">Or reach us directly</div>
              <div className="mt-5 space-y-4 text-sm">
                <a href={SITE.phoneHref} className="flex items-center gap-2 text-white hover:text-[var(--es-accent)]"><Phone size={18} weight="fill" />{SITE.phone}</a>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 text-white hover:text-[var(--es-accent)]"><EnvelopeSimple size={18} weight="fill" />{SITE.email}</a>
                <div className="flex items-start gap-2 text-white/85"><MapPin size={18} weight="fill" className="mt-0.5" /><span>{SITE.address.line1}<br />{SITE.address.city}, {SITE.address.state} {SITE.address.zip}</span></div>
              </div>
            </div>

            <div className="bg-white border border-[var(--es-border)] p-7 rounded-sm">
              <div className="text-xs uppercase tracking-[0.25em] text-[var(--es-accent)] font-semibold">Why Businesses Choose Empire Serv</div>
              <ul className="mt-5 space-y-3 text-sm">
                {WHY.map((w) => (
                  <li key={w.text} className="flex items-start gap-2.5 text-[var(--es-text)]">
                    <w.icon size={18} weight="fill" className="text-[var(--es-accent)] mt-0.5 flex-shrink-0" />
                    <span>{w.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      {/* Or book a walkthrough */}
      <section className="es-section bg-[var(--es-navy-deep)]" data-testid="quote-walkthrough-section">
        <div className="es-container">
          <div className="max-w-2xl mb-8">
            <div className="text-xs uppercase tracking-[0.3em] text-[var(--es-accent)] font-semibold">Prefer to meet in person?</div>
            <h2 className="es-h2 text-white mt-3">Skip the form — book a walkthrough.</h2>
            <p className="mt-4 text-white/70">Facility managers and contracting officers often prefer an on-site conversation. Pick a date and time and we'll bring the proposal to you.</p>
          </div>
          <WalkthroughScheduler variant="dark" />
        </div>
      </section>
    </>
  );
}
